module.exports = __webpack_public_path__ + "static/media/04_sognolucido.9d223b62.jpg";